// SPA mode: fully client-rendered, no SSR or prerender.
// This is what keeps module-level browser access (localStorage in
// $service/store, window/document listeners in $service/sse) from ever
// running on the server at build time.
export const ssr = false;
export const prerender = false;
